import { Outlet } from "react-router-dom";
import Header from '../../components/Header'

const Home = () => {
    return <div className="fullscreen">
        <Header />
        <div>
            <Outlet />
        </div>
    </div>
}

export default Home